import * as React from 'react';

import { useAiPoweredSearchExperiment } from 'bundles/search-common/providers/AiPoweredSearchExperimentProvider';
import { CoachStateProvider, useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';
import { TwoPanelChatRouteProvider } from 'bundles/unified-common/providers/TwoPanelChatRouteProvider';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

const ResetCoachOnSearchVariantChange = ({ children, resetKey }: React.PropsWithChildren<{ resetKey: boolean }>) => {
  const { setCoachOpen } = useCoachState();

  // Global Coach state survives navigation, so reset it before Search paints a new variant.
  useIsomorphicLayoutEffect(() => {
    setCoachOpen(false);
  }, [resetKey, setCoachOpen]);

  return <>{children}</>;
};

function SearchCoachProvider({ children }: React.PropsWithChildren) {
  const { enableConversationalSearch } = useAiPoweredSearchExperiment();

  return (
    <CoachStateProvider coachOpen={false}>
      <ResetCoachOnSearchVariantChange resetKey={enableConversationalSearch}>
        {enableConversationalSearch ? <TwoPanelChatRouteProvider>{children}</TwoPanelChatRouteProvider> : children}
      </ResetCoachOnSearchVariantChange>
    </CoachStateProvider>
  );
}

export default SearchCoachProvider;
